import React from "react"

function IconStatusAvailable({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (<svg  fill={color} fuze-icon="status-available"viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{height: height || fontSize}} originalclass="fz-icon fz-icon-status-available"{...props}><path d="M21.849 12.125c0 5.49-4.452 9.942-9.943 9.942-5.493 0-9.942-4.451-9.942-9.942a9.94 9.94 0 0 1 9.942-9.943c5.491 0 9.943 4.45 9.943 9.943" fill={color} fillRule="evenodd" style={{height: height || fontSize}} originalclass="__success"/></svg>)
}

export default IconStatusAvailable
